import React, { useState } from "react";
import { toast } from "react-toastify";

const NewAssessmentType = ({ onSubmit, title }) => {
    const nameRef = React.createRef();
    const iconRef = React.createRef();
    const [general, setGeneral] = useState(true);
    return (
        <form
            method="POST"
            onSubmit={(e) => {
                e.preventDefault();
                let item = {};
                const name = nameRef.current.value;
                item.name = name;
                if (iconRef.current) item.icon = iconRef.current.value;
                if (name) {
                    onSubmit(item);
                    nameRef.current.value = "";
                    if (iconRef.current) iconRef.current.value = "";
                } else {
                    toast.info(`Assessment ${title || ""}'s name is required!`);
                }
            }}
        >
            <div className="form-row">
                <div className="col-4">
                    <input type="text" id={`new-${title || ""}`} name={`new-${title || ""}`} ref={nameRef} className="form-control input-height" placeholder={`New assessment ${title}..`} />
                </div>
                {title === "Type" && (
                    <>
                        <div className="col-3">
                            <input type="text" id="icon-name-id" name="icon-name-id" ref={iconRef} className="form-control input-height" placeholder={`enter icon ${title}..`} />
                        </div>
                        <div className="col-3 mt-2">
                            <div className="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    onChange={({ currentTarget }) => setGeneral(currentTarget.checked)}
                                    defaultChecked={general}
                                    className="custom-control-input"
                                    id="defaultUnchecked"
                                />
                                <label className="custom-control-label" htmlFor="defaultUnchecked">
                                    Make Global
                                </label>
                            </div>
                        </div>
                    </>
                )}

                <div className="col">
                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-5 btn-circle btn-success">
                        Add {title || ""} <i className="material-icons">arrow_right_alt</i>
                    </button>
                </div>
            </div>
        </form>
    );
};
export default NewAssessmentType;
